module.exports = __webpack_public_path__ + "assets/62f479a2288e1df6f860dfa2df82abd2.png";